export const label = {
  'pt-BR': 'Mostrar senha',
  'pt-PT': 'Mostrar palavra-passe',
  'zh-TW': '顯示密碼',
  ar: 'إظهار كلمة المرور',
  az: 'Parolu göstər',
  be: 'Паказаць пароль',
  bg: 'Покажи паролата',
  bs: 'Prikaži lozinku',
  cnr: 'Prikaži lozinku',
  cs: 'Zobrazit heslo',
  da: 'Vis adgangskode',
  de: 'Passwort anzeigen',
  el: 'Εμφάνιση κωδικού πρόσβασης',
  en: 'Show password',
  es: 'Mostrar contraseña',
  et: 'Näita parooli',
  fi: 'Näytä salasana',
  fr: 'Afficher le mot de passe',
  he: 'הצג סיסמה',
  hr: 'Prikaži lozinku',
  hu: 'Jelszó megjelenítése',
  hy: 'Ցուցադրել գաղտնաբառը',
  id: 'Tampilkan sandi',
  is: 'Sýna lykilorð',
  it: 'Mostra password',
  ja: 'パスワードを表示',
  ka: 'პაროლის ჩვენება',
  ko: '비밀번호 표시',
  lt: 'Rodyti slaptažodį',
  lv: 'Rādīt paroli',
  mk: 'Прикажи лозинка',
  nl: 'Wachtwoord tonen',
  no: 'Vis passord',
  pl: 'Pokaż hasło',
  pt: 'Mostrar palavra-passe',
  ro: 'Arată parola',
  ru: 'Показать пароль',
  sk: 'Zobraziť heslo',
  sl: 'Prikaži geslo',
  sq: 'Shfaq fjalëkalimin',
  sr: 'Prikaži lozinku',
  sv: 'Visa lösenord',
  th: 'แสดงรหัสผ่าน',
  tr: 'Şifreyi göster',
  uk: 'Показати пароль',
  vi: 'Hiển thị mật khẩu',
  zh: '显示密码',
};
